import { useCallback, useRef } from 'react';

export const useImageUpload = (
  updateAttributes: (attrs: Record<string, unknown>) => void,
) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const openFileDialog = useCallback(() => {
    fileInputRef.current?.click();
  }, []);

  const handleFileSelect = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const file = event.target.files?.[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = e => {
          updateAttributes({ src: e.target?.result as string });
        };
        reader.readAsDataURL(file);
      }
    },
    [updateAttributes],
  );

  return { fileInputRef, openFileDialog, handleFileSelect };
};
